<template>
  <div>
    <div>
      <div class="sixteentosix sixteentosix-wrap omt-6 omt-md-25">
        <div class="new-background-wrap">
          <div
            class="kachelimage header-image zoom-image"
            style="
              background: url('/static/img/default_header.png');
              background-position: top !important;
            "
          ></div>
          <!-- <img src="/static/img/default_header.png" /> -->
          <div class="headline-wrap">
            <div class="headline">
              <div class="text-subtitle-2 text-md-h5">
                {{ $t("training_event_categorys") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div class="pt-8">
      <div class="row disablerow justify-content-between align-items-start">
        <v-dialog v-model="openDeleteDialog" width="500">
          <div class="Delete-popup-trainer-productivity">
            <img src="/static/img/alert-icon.svg" />
            <p>{{ $t("confirm_delete_category") }}</p>
            <div class="trainer-productivity-buttons-wrap">
              <div class="spacer"></div>
              <v-btn
                @click="openDeleteDialog = false"
                outlined
                depressed
                tile
                class="cancelBtn mr-2 mb-2"
              >
                {{ $t("cancel") }}</v-btn
              >
              <v-btn
                @click="deleteEventTrainingEventCategory(eventCategoryValue)"
                outlined
                depressed
                tile
                class="savebutton mr-2 mb-2"
              >
                <img
                  class="popup-delete-icon"
                  src="/static/img/popup-delete-icon.svg"
                />{{ $t("delete") }}
              </v-btn>
            </div>
          </div>
        </v-dialog>
        <div class="mx-0 row align-items-start ETC-background-wrapper">
          <div class="ETC-background-wrap-1 col-xl-9">
            <div
              class="px-md-4 pt-4 mx-0 pa-0 row justify-content-sm-between justify-content-center innercreatetraining ETC-background-wrap"
            >
              <div
                class="col-xl-12 pl-0 pr-0 right-side-block sa-buttons-ustom-te"
                id="buttons-custom-te"
                style="display: flex"
              >
                <div class="col-md-4 pt-0 text-start pl-0">
                  <span class="headlinecolor text-h6">
                    {{ $t("training_event_categorys") }}</span
                  >
                </div>
                <div class="col-md-8 pt-0 pr-0 justify-content-right d-flex g-space-15">
                  <v-btn
                    @click="cancel()"
                    outlined
                    depressed
                    tile
                    class="cancelBtn back-etc-wrap pl-2 pr-4"
                    ><v-icon>mdi-menu-left</v-icon>{{ $t("back") }}</v-btn
                  >
                  <v-btn
                    :to="{ path: '/training-event-category' }"
                    v-show="$rights.includes('CREATE_TRAINING_EVENT_CATEGORY')"
                    outlined
                    depressed
                    tile
                    class="savebutton pl-4 pr-4"
                    style="margin-right: 0 !important"
                    >{{ $t("create_training_event_category") }}</v-btn
                  >
                </div>
              </div>
              <div class="row disablerow justify-content-between">
                <v-simple-table
                  class="tenantstable sa-tenantstable"
                  style="width: 100%"
                  hide-default-footer
                >
                  <thead style="display: none">
                    <tr>
                      <th
                        @click="
                          (sort = 'eventCategoryName'),
                            (order = !order),
                            (page = 1),
                            fetchEventTrainingCategory()
                        "
                        class="text-uppercase align-bottom"
                      >
                        {{ $t("training_event_categorys") }}
                        <v-icon v-show="sort == 'eventCategoryName' && order"
                          >fas fa-chevron-down</v-icon
                        ><v-icon v-show="sort == 'eventCategoryName' && !order"
                          >fas fa-chevron-up</v-icon
                        >
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="etc-tr"
                      v-for="eventTrainingCategory in eventTrainingCategories1"
                      :key="eventTrainingCategory.value"
                    >
                      <td class="">{{ eventTrainingCategory.text }}</td>
                      <td class="btn_collab">
                        <v-tooltip
                          bottom
                          v-show="
                            $rights.includes('UPDATE_TRAINING_EVENT_CATEGORY')
                          "
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                            v-show="
                              $rights.includes('UPDATE_TRAINING_EVENT_CATEGORY')
                            "
                          >
                            <v-btn
                              v-show="
                                $rights.includes(
                                  'UPDATE_TRAINING_EVENT_CATEGORY'
                                )
                              "
                              color="transparent"
                              depressed
                              tile
                              v-bind="attrs"
                              v-on="on"
                              ><a
                                @click="
                                  goToEventCategory(eventTrainingCategory)
                                "
                                ><img
                                  class="mr-2"
                                  src="../assets/img/sa-edit.svg" /></a
                            ></v-btn>
                          </template>
                          <span>{{ $t("edit_training_event_category") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color
                              depressed
                              tile
                              v-bind="attrs"
                              v-on="on"
                              @click="
                                $router.push(
                                  '/category-details?categoryId=' +
                                    eventTrainingCategory.value
                                )
                              "
                              ><i
                                data-v-52705b1a=""
                                aria-hidden="true"
                                class="v-icon etc-preview-icon notranslate mdi mdi-eye theme--light"
                              ></i
                            ></v-btn>
                          </template>
                          <span>{{ $t("view") }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-show="
                            $rights.includes('DELETE_TRAINING_EVENT_CATEGORY')
                          "
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                            v-show="
                              $rights.includes('DELETE_TRAINING_EVENT_CATEGORY')
                            "
                          >
                            <v-btn
                              v-show="
                                $rights.includes(
                                  'DELETE_TRAINING_EVENT_CATEGORY'
                                )
                              "
                              @click="openDelete(eventTrainingCategory.value)"
                              color="transparent"
                              class="tablebutton"
                              depressed
                              tile
                              v-bind="attrs"
                              v-on="on"
                              ><i
                                aria-hidden="true"
                                class="v-icon notranslate mdi mdi-delete mdi-delete-wrapper theme--light"
                                style="
                                  color: rgb(68, 68, 68);
                                  caret-color: rgb(68, 68, 68);
                                "
                              ></i
                            ></v-btn>
                          </template>
                          <span>{{
                            $t("delete_training_event_category")
                          }}</span>
                        </v-tooltip>
                        <div class="text-center"></div>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <pagination
                  class="my-2"
                  :current-page="page"
                  :total-pages="totalPages"
                  :show-previous-page="previousPage"
                  :show-next-page="nextPage"
                  :show-current-page="showCurrentPage"
                ></pagination>
              </div>
            </div>
          </div>
          <div class="col-xl-3 ml-1 px-0 pl-md-12 pl-lg-8 row pt-0 onlyContact">
            <Contact />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pagination from "./custom/pagination.vue";
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    pagination,
    Breadcrumb,
  },

  data() {
    return {
      page: 1,
      totalPages: 1,
      ElementPerPage: 50,
      sort: null,
      order: true,
      routes: {
        eventTrainingCategorys: "/api/eventTrainingCategory",
      },
      search: "",
      rules: [(value) => !!value || this.$t("required")],
      eventTrainingCategory: [],
      roles: [],
      menu: false,
      createmode: true,

      me: null,
      openDeleteDialog: false,
      eventCategoryValue: null,
      isLoad: false,
    };
  },
  computed: {
    eventTrainingCategories1() {
      const eventTrainingCategory = Array.isArray(this.eventTrainingCategory)
        ? this.eventTrainingCategory.map((eventTrainingCategories) => ({
            value: eventTrainingCategories.id,
            text: eventTrainingCategories.designationsMap[this.$locale],
          }))
        : [];

      return eventTrainingCategory;
    },
  },
  mounted() {
    if (
      !this.isLoad &&
      !window.location.href.includes("?") &&
      !window.location.href.includes("?lang=")
    ) {
      this.isLoad = true;
      window.location.href =
        window.location.href + "?lang=" + this.$locale.toUpperCase();
    } else if (
      window.location.href.includes("?") &&
      !window.location.href.includes("&lang=") &&
      !window.location.href.includes("?lang=")
    ) {
      this.isLoad = true;
      window.location.href =
        window.location.href + "&lang=" + this.$locale.toUpperCase();
    }
    Vue.prototype.$locale = this.$locale.toLowerCase();
    this.fetchEventTrainingCategory();
  },

  methods: {
    // navigateToCategoryDetail(eventTrainingCategory) {
    //   this.$routerPush('/category-details?categoryId='+ eventTrainingCategory.value);
    // },

    goToEventCategory(eventTrainingCategory) {
      this.$router.push(
        "/training-event-category?trainingeventcategoryId=" +
          eventTrainingCategory.value
      );
    },
    cancel() {
      if (this.$rights.includes("VIEW_TRAINING_EVENT")) {
        this.$router.push("/training-events");
      } else {
        this.$router.push("/categories");
      }
    },
    openDelete(val) {
      this.eventCategoryValue = val;
      this.openDeleteDialog = true;
    },
    previousPage() {
      this.page = this.page - 1;
      this.fetchEventTrainingCategory();
    },
    nextPage() {
      this.page = this.page + 1;
      this.fetchEventTrainingCategory();
    },
    showCurrentPage(pageNumber) {
      this.page = pageNumber;
      this.fetchEventTrainingCategory();
    },

    onError(err) {
      console.log(err);
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    fetchEventTrainingCategory() {
      var _this = this;
      this.$axios
        .get(this.routes.eventTrainingCategorys, {
          params: {
            search: _this.search,
            sort: _this.sort,
            order: _this.order ? "ASC" : "DESC",
            page: _this.page - 1,
            size: _this.ElementPerPage,
          },
        })
        .then(function (response) {
          _this.eventTrainingCategory = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },

    deleteEventTrainingEventCategory(trainingEventCategoryId) {
      var _this = this;
      this.$axios
        .delete(
          "api/eventTrainingCategory/" + parseInt(trainingEventCategoryId, 10)
        )
        .then(function (response) {
          _this.$noty.success(_this.$t("training_event_category_deleted"));
          _this.fetchEventTrainingCategory();
          _this.eventTrainingCategory = [];
          _this.$forceUpdate();
          _this.openDeleteDialog = false;
        })
        .catch(this.onError);
    },
  },
};
</script>
